import styled from "@emotion/styled";

import BulletPoint from "./bullet-point.svg";

export const StyledSubHeadlineText = styled.div``;

export const StyledBulletPoint = styled(BulletPoint)`
  order: -1;

  margin-inline-end: 12px;
  ${props => props.theme.breakpoints.up("tablet")} {
    margin-inline-end: 16px;
  }

  ${props => props.theme.breakpoints.up("desktop")} {
    margin-inline-end: 20px;
  }

  ${props => props.theme.breakpoints.up("largeDesktop")} {
    margin-inline-end: 24px;
  }
`;

export const BulletPointWrapper = styled.div`
  display: flex;
  > ${StyledSubHeadlineText}:empty + ${StyledBulletPoint} {
    display: none;
  }
`;
